import { Component, computed, inject, InjectionToken, OnInit, ViewEncapsulation } from '@angular/core';
import { IonContent, IonHeader, IonToolbar, IonTitle, IonButtons, IonBackButton } from "@ionic/angular/standalone";
import { NavbarComponent } from "../ui/navbar/navbar.component";
import { MenuItem } from 'src/app/models/menu-item';
import { SessionService } from 'src/app/services/session.service';
import { PopoverButton } from '../ui/popover-buttons/popover-buttons.component';
import { AuthService } from 'src/app/services/auth.service';
import { NavController } from '@ionic/angular';
import { LocalizationModule } from "../../modules/localization/localization.module";

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
  standalone: true,
  imports: [IonBackButton, IonButtons, IonTitle, IonToolbar, IonHeader, IonContent, NavbarComponent, LocalizationModule],
})
export class TermsAndConditionsComponent {
  sessionService = inject(SessionService);
  authService = inject(AuthService);
  navController = inject(NavController);

  menuItems = computed<MenuItem[]>(() => [
    { label: "Home", href: "/", icon: "home-outline" },
    { label: "Support", href: "/dashboard/support", icon: "help-circle-outline" },
  ]);

  popoverButtons = computed(() => {
    const buttons: PopoverButton[] = [];
    const loggedIn = this.sessionService.isLoggedIn();
    if (loggedIn) {
      buttons.push({ label: "Log out", action: () => this.authService.logout() });
    } else {
      buttons.push({ label: "Log in", action: () => this.navController.navigateRoot('/auth/login') });
    }
    return buttons;
  });
}
